// Kilkaya tracking code for single-page applications
export { K5A } from './k5a';
// Returns API host name
export { apihost } from './apihost';
// Modify and return query part of URL fragment (hash)
export { hashquery } from './hashquery';
// OAUTH2 login
export { oauth, set_access_token, get_access_token } from './oauth';
// Add thousand separators to numbers
export { numfmt } from './numfmt';
// Convert integer to numeral (number word from 0 - 10, digit string above 10)
export { numeral, numeralform } from './numeral';
// Convert byte size to human readable size (1000 == 1kB)
export { humsize } from './humsize';
// Replace breaking characters with nonbreaking ones
export { numnowrap } from './numnowrap'; // Thousand separators
export { nowrap } from './nowrap'; // Spaces and dashes
// Convert only first character in string to either lower case or upper case
export { lcfirst } from './lcfirst';
export { ucfirst } from './ucfirst';
// Capitalize first letter and add period at end
export { sentence } from './sentence';
// PHP style trim() function
export { trim, trimflags } from './trim';
// String with municipality name and designator from MunicipalityType
export { muniname } from './muniname';
// Convert 5-digit SSB table IDs to HTML links
export { ssblnk } from './ssblnk';
// Append 's' to strings not ending on 's', otherwise apostrof.
export { genitive } from './genitive';
// True when viewport width is within media query 'mobile' breakpoint
export { vpmobile } from './vpmobile';
// True when viewport is wider than maximum content width
export { vpmaxwidth } from './vpmaxwidth';
// True when viewport is wider than the semantic-ui grid's breakpoint
export { vpuigrd } from './vpuigrd';
// True when viewport is very narrow (420px or less)
export { vptiny } from './vptiny';
// True if current browser most likely has a virtual keyboard
export { virtkbd } from './virtkbd';
// External URLs
export { urlcdn } from './urlcdn';
export { urllogout } from './urllogout';
export { urlstartpage } from './urlstartpage';
export { urlsubscribe } from './urlsubscribe';
// Get paywall jwt token or single field
export { pwtoken } from "./pwtoken";
// Manipulates user data in localStorage
export { getstg, setstg, clrstg } from "./stg";
// Functions for setting and retrieving user messages
// across renderings and page loads
export { pushmsg, popmsg, clrmsg } from "./msg";
export { path2doctype } from "./path2doctype";
// Quick and dirty parameter validation
export { isfnr, isknr, isyear, issector } from "./validation";
